(function(){
'use strict';
function phrase(name){
var n=(name||'').toLowerCase();
if(/volum|rotskumm|rotsk(u|)m/.test(n))return 'Skap luftig fylde og løft ved røttene.';
if(/tørrsjampo|torrsjampo/.test(n))return 'Frisk opp håret mellom vaskene.';
if(/hårspray|harspray/.test(n))return 'Gi frisyren en fin avslutning med hold.';
if(/argan|hårolje|harolje/.test(n))return 'Gi lengdene mykhet og vakker glans.';
if(/sjampo|shampoo/.test(n))return 'En god hårdag begynner med riktig vask.';
if(/balsam|conditioner/.test(n))return 'Mykere lengder som er lettere å gre.';
if(/hårkur|harkur|maske/.test(n))return 'Gi lengdene en ekstra dose pleie.';
if(/skum|mousse/.test(n))return 'Gjør håret klart for en luftig styling.';
if(/pomade|voks|wax/.test(n))return 'Form frisyren med tekstur og kontroll.';
if(/børste|borste|kam/.test(n))return 'Mer kontroll gjennom hver seksjon.';
if(/trimmer|klippemaskin|shaver/.test(n))return 'Et verktøy for presise detaljer.';
if(/farge|toner|oxidant/.test(n))return 'For profesjonelt fargearbeid i salong.';
return 'Et gjennomtenkt valg til denne guiden.';
}
function build(old){
if(old.dataset.grimmStandardDone)return;
var form=old.querySelector('form[data-grimm-cart-add]');
if(!form)return;
var links=Array.from(old.querySelectorAll('a[href*="/products/"]'));
var photo=links.find(function(x){return x.querySelector('img')});
var name=links.find(function(x){return !x.querySelector('img')});
var price=old.querySelector('[data-grimm-shopify-price]');
if(!photo||!name||!price)return;
old.dataset.grimmStandardDone='1';
var row=document.createElement('div');row.className='grimm-article-shop grimm-standard-card';
var pic=document.createElement('a');pic.href=photo.href;pic.className='grimm-standard-card__image';
var img=photo.querySelector('img').cloneNode(true);img.removeAttribute('style');img.width=86;img.height=86;pic.appendChild(img);
var info=document.createElement('div');info.className='grimm-standard-card__info';
var title=document.createElement('a');title.href=name.href;title.className='grimm-standard-card__title';title.textContent=name.textContent.trim();
var line=document.createElement('span');line.className='grimm-article-shop__one-liner';line.textContent=phrase(title.textContent);
var cost=document.createElement('span');cost.className='grimm-standard-card__price';cost.appendChild(price);
info.appendChild(title);info.appendChild(line);info.appendChild(cost);
var button=form.querySelector('button');if(button){button.replaceChildren();button.innerHTML='<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2 10h12l2-8H6"></path><circle cx="9" cy="20" r="1"></circle><circle cx="18" cy="20" r="1"></circle><path d="M12 7v6m-3-3h6"></path></svg>';}
row.appendChild(pic);row.appendChild(info);row.appendChild(form);old.replaceWith(row);var wrapper=row.parentElement;if(wrapper&&wrapper.hasAttribute('style')&&wrapper.style.display==='flex'){wrapper.style.display='block';wrapper.style.margin='0';wrapper.style.padding='0';}
}
function run(){
var root=document.querySelector('[data-attr="grimm-article-body"]');if(!root)return;
root.querySelectorAll('form[data-grimm-cart-add]').forEach(function(form){
var old=form.closest('div[style*="flex:1 1 230px"]');if(old)build(old);
});
root.querySelectorAll('[data-grimm-product-cards]').forEach(function(block){block.style.margin='16px 0 28px';block.style.padding='0';block.style.background='transparent';block.style.border='0';block.querySelectorAll(':scope > h2,:scope > p').forEach(function(n){n.remove()});
if(!block.querySelector('form[data-grimm-cart-add]'))block.remove();
});
root.querySelectorAll('.grimm-article-shop__details').forEach(function(details){
if(details.querySelector('.grimm-article-shop__one-liner'))return;
var a=details.querySelector('a');if(!a)return;var line=document.createElement('span');line.className='grimm-article-shop__one-liner';line.textContent=phrase(a.textContent);a.after(line);
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();